import { render, staticRenderFns } from "./Circuit.vue?vue&type=template&id=a805d580&scoped=true&"
import script from "./Circuit.vue?vue&type=script&lang=js&"
export * from "./Circuit.vue?vue&type=script&lang=js&"
import style0 from "./Circuit.vue?vue&type=style&index=0&id=a805d580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a805d580",
  null
  
)

export default component.exports